import Menu from '@mui/material/Menu';
import type { CustomContextMenuOptions } from './CustomContextMenuContainer.tsx';
import ContextMenuItem from './ContextMenuItem.tsx';
import type React from 'react';

export type CustomContextMenuProps = {
  anchorPosition?: { top: number; left: number };
  options: CustomContextMenuOptions;
  open: boolean;
  onClose: () => void;
  handleClick: (e: React.MouseEvent<HTMLElement>, callback: () => void) => void;
};

const CustomContextMenu = ({ handleClick, anchorPosition, options, open, onClose }: CustomContextMenuProps) => {
  return (
    <Menu
      open={open}
      onClose={onClose}
      anchorReference="anchorPosition"
      anchorPosition={anchorPosition}
      autoFocus={false}
      disableAutoFocusItem
      disableEnforceFocus
      disableScrollLock={anchorPosition !== null}
      disableRestoreFocus
    >
      <ContextMenuItem options={options} handleClick={handleClick} />
    </Menu>
  );
};

export default CustomContextMenu;
